export default __webpack_public_path__ + "static/media/icon-favourite.4ca4bc13.svg";